import { render, staticRenderFns } from "./CustomApexLegends.vue?vue&type=template&id=6dd8e0da&scoped=true&"
import script from "./CustomApexLegends.vue?vue&type=script&lang=js&"
export * from "./CustomApexLegends.vue?vue&type=script&lang=js&"
import style0 from "./CustomApexLegends.vue?vue&type=style&index=0&id=6dd8e0da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8e0da",
  null
  
)

export default component.exports